import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import consts from '../consts';

import {
	initFormPergunta as initForm
} from './checklistActions';
import ButtonTable from '../common/table/buttonTable';

class ChecklistPerguntaForm extends Component {

	state = {

	}

	componentWillMount() {

		let initSeletorImagem = () => {
			const fileSelectorImagem = document.createElement('input');
			fileSelectorImagem.setAttribute('type', 'file');
			fileSelectorImagem.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {

						this.props.initForm({
							...this.props.formularioValues,
							imagem_base64: reader.result
						});

						initSeletorImagem();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorImagem = fileSelectorImagem;

		}

		initSeletorImagem();
	}

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		const perguntaPai = this.props.formularioValues.listaComDependencia.filter(item => item.id == this.props.formularioValues.id_pai)[0];
		
		return (
			<>
				<ContentCard>
					<Form event={this.props.handleSubmit}>
						<ContentCardBody>
							<Row>						
									
								<Select
									name='id_tipo'
									label='Tipo' placeholder='Informe o tipo'
									options={this.props.listaTipoPergunta}
									cols='12 12 12 12'
									readOnly={readOnly}
									value={this.props.formularioValues.id_tipo}
									onChange={value => {
										let registro = {
											...this.props.formularioValues,
											id_tipo: value
										};
										
										if (this.props.formularioValues.id_tipo == 11 && value != 11) { //Assinatura
											//Se estava como assinatura limpa os campos preenchidos automaticamente
											registro = {
												...registro,
												descricao: '',
												complemento_assinatura: false,
												quantidade_assinatura: 0,
												quantidade_assinatura_obrigatoria: 0
											};
										} else if (value == 11) { //Assinatura
											//Se foi selecionado assinatura preenche os campos automaticamente
											registro = {
												...registro,
												descricao: 'Assinatura',
												complemento_assinatura: true
											};
										}
										this.props.initForm(registro);
									}} />
								
								{this.props.formularioValues.id_tipo != 11 && //Assinatura
								<Field
									name='descricao'
									component={LabelAndInput}
									label='Descrição' placeholder='Informe a descrição'
									cols='12 12 12 12'
									readOnly={readOnly} />}
								
								{this.props.formularioValues.id_tipo == 11 && //Assinatura
								<Field
									name='quantidade_assinatura'
									component={Select}
									label='Quantidade de Assinaturas' placeholder='Informe'
									options={[{ id: 0, valor: 'Nenhuma assinatura' }, { id: 1, valor: '1 assinatura' }, { id: 2, valor: '2 assinaturas' }, { id: 3, valor: '3 assinaturas' }, { id: 4, valor: '4 assinaturas' }]}
									cols='12 12 12 12'
									readOnly={readOnly} />}
								
								{this.props.formularioValues.id_tipo == 11 && //Assinatura
								<Field
									name='quantidade_assinatura_obrigatoria'
									component={Select}
									label='Quantidade de Assinaturas Obrigatórias' placeholder='Informe'
									options={[{ id: 0, valor: 'Nenhuma assinatura' }, { id: 1, valor: '1 assinatura' }, { id: 2, valor: '2 assinaturas' }, { id: 3, valor: '3 assinaturas' }, { id: 4, valor: '4 assinaturas' }]}
									cols='12 12 12 12'
									readOnly={readOnly} />}
							
								{(this.props.formularioValues.listaComDependencia || []).length > 0 &&
								<Field
									name='id_pai'
									component={Select}
									label='Dependência' placeholder='Informe se possui dependência'
									options={this.props.formularioValues.listaComDependencia.map(item => ({ id: item.id, valor: item.descricao}))}
									cols='12 12 12 12'
									readOnly={readOnly} />}
									
								{(this.props.formularioValues.id_pai && perguntaPai) &&
								<Field
									name='pai_condicao'
									component={Select}
									label='Condição' placeholder='Informe a condição esperada'
									options={[{ id: 'Sim', valor: perguntaPai.dependente_condicao_1 || 'Sim' },{ id: 'Não', valor: perguntaPai.dependente_condicao_2 || 'Não' }]}
									cols='12 12 12 12'
									readOnly={readOnly} />}

							</Row>

							{(this.props.formularioValues.id_tipo == 5 || this.props.formularioValues.id_tipo == 6) && //Lista de Seleção Única e Lista de Seleção Múltipla
							<Row>
								{this.props.formularioValues.opcoes.map((opcao, i) => (
									<Grid key={opcao.id} cols='12 12 12 12'>
										<div
											style={{
												display: 'flex',
												justifyContent: 'start',
												alignItems: 'center'
											}}>
											<LabelAndInput
												label={`Opção ${i+1}`} placeholder='Informe'
												cols='11 11 11 11'
												readOnly={readOnly}
												value={opcao.nome}
												onChange={data => {
													this.props.initForm({
														...this.props.formularioValues,
														opcoes: this.props.formularioValues.opcoes.map(item => ({
															...item,
															nome: item.id == opcao.id ? data.target.value : item.nome
														}))
													});
												}} />

											<ButtonTable
												type={'danger'}
												marginTop={16}
												icon={'fas fa-trash-alt'}
												visible={!readOnly}
												event={() => {
													let lista = this.props.formularioValues.opcoes.map(item => ({ ...item })).filter(item => item.id != opcao.id);

													this.props.initForm({
														...this.props.formularioValues,
														opcoes: lista
													});
												}} />
										</div>
									</Grid>
								))}
							</Row>}

							{(this.props.formularioValues.id_tipo == 5 || this.props.formularioValues.id_tipo == 6) && //Lista de Seleção Única e Lista de Seleção Múltipla
							<Row style={{ marginTop: 12, marginBottom: 16 }}>
								<Grid cols='12 12 6 4'>
									<Button
										text='Adicionar Opção'
										type={'primary'}
										icon={'fa fa-chevron-left'}
										event={() => {
											let lista = this.props.formularioValues.opcoes.map(opcao => ({ ...opcao }));

											lista.push({
												id: new Date().getTime(),
												nome: ''
											});

											this.props.initForm({
												...this.props.formularioValues,
												opcoes: lista
											});
										}} />
								</Grid>
							</Row>}
							
							<Row>
								{this.props.formularioValues.id_tipo == 8 && //Seleção Interativa (Silo)
								<Field
									name='id_equipamento'
									component={Select}
									label='Equipamento' placeholder='Informe o equipamento'
									options={this.props.listaEquipamento}
									cols='12 12 12 12'
									readOnly={readOnly} />}

								{this.props.formularioValues.id_tipo != 11 && //Assinatura
								<Field
									name='obrigatorio'
									component={LabelAndCheckbox}
									label='Obrigatória' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={readOnly} />}
							</Row>

							{this.props.formularioValues.id_tipo == 9 && //Pergunta com dependentes
							<Row>
								<Field
									name='dependente_condicao_1'
									component={LabelAndInput}
									label='Condição 1' placeholder='Informe a condição'
									cols='12 12 12 12'
									readOnly={readOnly} />
									
								<Field
									name='dependente_condicao_2'
									component={LabelAndInput}
									label='Condição 2' placeholder='Informe a condição'
									cols='12 12 12 12'
									readOnly={readOnly} />
							</Row>}

							<Row>
								<Grid cols='12 12 12 12'>

									<Row style={{ paddingBottom: 16 }}>
										<Grid cols='12 12 12 12'>
											<label>Imagem</label>
										</Grid>
										{(this.props.formularioValues.imagem || this.props.formularioValues.imagem_base64) ? (
											<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 10 }}>
												<span class="btn btn-outline-secondary fileinput-button dz-clickable">
													<img 
														src={this.props.formularioValues.imagem_base64 
															? this.props.formularioValues.imagem_base64
															: `${consts.URL}/${this.props.formularioValues.imagem}`
														} 
														style={{ height: 200 }} />
												</span>
												<button
													type='button'
													class='btn btn-flat btn-outline-danger'
													style={{ width: 40, height: 40 }}
													disabled={readOnly}
													onClick={() => {
														this.props.initForm({
															...this.props.formularioValues,
															imagem: null,
															imagem_base64: null
														});
													}}>
													<i class='fas fa-trash-alt'></i>
												</button>
											</div>
										) : (									
											<span class="btn btn-outline-secondary fileinput-button dz-clickable"
												style={{ marginLeft: 10 }}
												onClick={() => this.fileSelectorImagem.click()}>
												<img src={pdfAdd} style={{ height: 40 }} />
											</span>
										)}
									</Row>

								</Grid>
							</Row>

							{this.props.formularioValues.id_tipo != 11 && //Assinatura
							<Row>
								<Grid cols='12 12 12 12'>
									<p style={{ fontWeight: 'bold' }}>Complementos</p>
								</Grid>
								<a class={`btn btn-app bg-${this.props.formularioValues.complemento_comentario ? 'success' : 'secondary'}`}
									onClick={() => this.props.initForm({ ...this.props.formularioValues, complemento_comentario: !this.props.formularioValues.complemento_comentario })}>
									<i class='fas fa-barcode'></i> Comentário
								</a>
								<a class={`btn btn-app bg-${this.props.formularioValues.complemento_anexo ? 'success' : 'secondary'}`}
									onClick={() => this.props.initForm({ ...this.props.formularioValues, complemento_anexo: !this.props.formularioValues.complemento_anexo })}>
									<i class='fas fa-barcode'></i> Anexo
								</a>
								<a class={`btn btn-app bg-${this.props.formularioValues.complemento_foto ? 'success' : 'secondary'}`}
									onClick={() => this.props.initForm({ ...this.props.formularioValues, complemento_foto: !this.props.formularioValues.complemento_foto })}>
									<i class='fas fa-barcode'></i> Foto
								</a>
								<a class={`btn btn-app bg-${this.props.formularioValues.complemento_assinatura ? 'success' : 'secondary'}`}
									onClick={() => this.props.initForm({ ...this.props.formularioValues, complemento_assinatura: !this.props.formularioValues.complemento_assinatura })}>
									<i class='fas fa-barcode'></i> Assinatura
								</a>
							</Row>}

							<div style={{ height: 100 }}></div>
	
						</ContentCardBody>
						<ContentCardFooter>
							<Row alignCenter>
								<Grid cols='6 6 4 3'>
									{this.props.excluir ? (
										<Button
											text='Excluir'
											submit type={'danger'}
											icon={'fa fa-trash'} />
									) : (
									<Button
										text='Salvar'
										submit
										type={'success'}
										icon={'fa fa-check'} />
									)}
								</Grid>
								<Grid cols='6 6 4 3'>
									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => this.props.initForm(null)} />
								</Grid>
							</Row>
						</ContentCardFooter>
					</Form>
				</ContentCard>

			</>
		);
    }

}

ChecklistPerguntaForm = reduxForm({form: 'checklistPerguntaForm', destroyOnUnmount: false})(ChecklistPerguntaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('checklistPerguntaForm')(state),
	registro: state.checklist.registro,
	listaTipoPergunta: state.checklist.listaTipoPergunta,
	listaEquipamento: state.equipamento.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ChecklistPerguntaForm);
